<div class="card mt-2">
  <div class="card-body">
    <h5>Encounters</h5>
    @if (!loadingEncounters) {
      @if (showIneligibleEncounters) {
        <nav class="nav nav-pills mb-2">
          <a class="nav-item nav-link active"
            [class.active]="currentTab === 'eligibleEncounters'"
            (click)="tabClick($event, 'eligibleEncounters')"
            href="#">
            Eligible Encounters ({{ eligibleEncounters.length }})
          </a>
          <a class="nav-item nav-link"
            [class.active]="currentTab === 'ineligibleEncounters'"
            (click)="tabClick($event, 'ineligibleEncounters')"
            href="#">
            Ineligible Encounters ({{ ineligibleEncounters.length }})
          </a>
        </nav>
      }
      @if (!showIneligibleEncounters || currentTab === 'eligibleEncounters') {
        <ng-container
          [ngTemplateOutlet]="encounterList"
          [ngTemplateOutletContext]="{ encounters: eligibleEncounters }" />
      }
      @if (currentTab === 'ineligibleEncounters') {
        <ng-container
          [ngTemplateOutlet]="encounterList"
          [ngTemplateOutletContext]="{ encounters: ineligibleEncounters, rowClass: 'ineligible' }" />
      }
    } @else {
      <mat-spinner [diameter]="30" />
    }
  </div>
</div>

<ng-template #encounterList let-encounters="encounters" let-rowClass="rowClass">
  @if (encounters.length > 0) {
    <div>
      <p>Encounters provided by client encounter feed.</p>
      <div class="scrollable">
        <table class="table table-sm">
          <thead>
            <th>ENC-ID</th>
            <th class="text-nowrap">Date &#x25BC;</th>
            <th class="text-nowrap">Provider</th>
            <th class="text-nowrap">Location</th>
            <th class="text-nowrap">Type</th>
          </thead>
          <tbody>
            @for (encounter of encounters; track encounter) {
              <tr class="encounter" [ngClass]="rowClass">
                <td>{{ encounter.ehrIdentifier }}</td>
                <td>{{ encounter.encounterDate | date: 'MM/dd/yyyy' }}</td>
                <td>{{ encounter.providerFirst }} {{ encounter.providerLast }} ({{ encounter.providerNpi }})</td>
                <td>{{ encounter.location }}</td>
                <td>{{ encounter.encounterType }}</td>
              </tr>
            }
          </tbody>
        </table>
        @if (moreEncountersThanDisplayed) {
          <div class="p-1 pt-0">
            Only displaying patient's 20 most recent encounters.
          </div>
        }
      </div>
    </div>
  } @else {
    <p>There are no encounters.</p>
  }
</ng-template>

